module.exports = __webpack_public_path__ + "static/media/img-ami-1-en.aea4e010.png";